module.exports = __webpack_public_path__ + "static/media/austrian_flag.c10d0326.jpg";